<template>
  <div>
    <el-alert v-if="generalError" :title="generalError.title" :description="generalError.description" type="error" show-icon style="margin-bottom: 12px;" :closable="false"/>
    <el-alert v-if="error" :title="error.title" :description="error.description" type="error" show-icon style="margin-bottom: 12px;" :closable="false"/>
    <el-alert v-if="rateLimitMessage" type="warning" show-icon style="margin-bottom: 12px;" :closable="false">
      <template #title>
        Veuillez patienter
      </template>
      <template #default>
        {{ rateLimitMessage }}
      </template>
    </el-alert>
    <h2 class="signup-form-title">{{$t('signup.phone.title')}}</h2>
    <div class="form-group">
      <p class="signup-form-description">{{$t('signup.phone.description')}}</p>
    </div>

    <el-form-item :label="$t('signup.phone.label')">
      <VueTelInput v-model="edit.phone" :inputOptions="inputOptions" mode="international" :default-country="'FR'" @country-changed="saveCountry"></VueTelInput>
    </el-form-item>
    <p class="condition-text"><Lock class="text-icon"/>{{$t('signup.phone.privacy')}}</p>
    
    <!-- Widget Turnstile invisible -->
    <div id="turnstile-widget-sms" style="display: none;"></div>
    
    <div class="form-group mt-4">
      <el-button class="signup-primary" :class="hasChanged && !isRateLimited ? '' : 'disabled'" @click="continu" :loading="isLoading" :disabled="isRateLimited || !hasChanged">
        {{$t('signup.continue')}}
      </el-button>
    </div>
  </div>
</template>

<script>
import { VueTelInput } from 'vue-tel-input';
import { parsePhoneNumberFromString } from 'libphonenumber-js'
import signupHandler from "../mixins/signupHandler.js";
import 'vue-tel-input/vue-tel-input.css';

export default {
  name: "RegisterPhoneNumber",
  mixins: [signupHandler],
  data () {
    return {
      inputOptions: {
        placeholder: this.$t('signup.phone.placeholder')
      },
      edit: {
        phone: '',
        country: ''
      },
      turnstileToken: null,
      turnstileWidgetId: null,
      turnstilePromise: null,
      turnstileResolve: null,
      turnstileReject: null,
      rateLimitMinutes: 5, // Délai en minutes entre chaque envoi
      rateLimitTimer: null,
      timeRemaining: 0
    }
  },
  created() {
    let user = JSON.parse(JSON.stringify(this.signupUser))
    if (user.telephone) {
      this.edit.phone = user.telephone.telephone
    }
    // Vérifier le rate limit au chargement
    this.checkRateLimit();
  },
  mounted() {
    this.initTurnstile();
    // Démarrer le timer si nécessaire
    if (this.isRateLimited) {
      this.startRateLimitTimer();
    }
  },
  beforeUnmount() {
    // Nettoyer le widget Turnstile
    if (this.turnstileWidgetId && window.turnstile) {
      window.turnstile.remove(this.turnstileWidgetId);
    }
    // Nettoyer le timer
    if (this.rateLimitTimer) {
      clearInterval(this.rateLimitTimer);
    }
  },
  computed: {
    submitUrl () {
      return 'user/send-sms-code'
    },
    parsePhoneNumber () {
      if (this.edit.phone.length < 5) {
        return parsePhoneNumberFromString(this.edit.phone)
      } else {
        return false
      }
    },
    hasChanged () {
      // return this.edit.phone.length > 5
      const phoneNumber = parsePhoneNumberFromString(this.edit.phone.replaceAll(' ', ''))
      return typeof phoneNumber !== 'undefined' && phoneNumber.isValid()
    },
    isRateLimited() {
      return this.timeRemaining > 0;
    },
    rateLimitMessage() {
      if (!this.isRateLimited) return null;
      
      const minutes = Math.floor(this.timeRemaining / 60);
      const seconds = this.timeRemaining % 60;
      
      if (minutes > 0) {
        return `Vous pourrez renvoyer un code dans ${minutes} minute${minutes > 1 ? 's' : ''} et ${seconds} seconde${seconds > 1 ? 's' : ''}`;
      } else {
        return `Vous pourrez renvoyer un code dans ${seconds} seconde${seconds > 1 ? 's' : ''}`;
      }
    }
  },
  methods: {
    initTurnstile() {
      // Vérifier si Turnstile est déjà chargé
      if (window.turnstile) {
        this.renderTurnstile();
      } else {
        // Charger le script Turnstile
        const script = document.createElement('script');
        script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js';
        script.async = true;
        script.defer = true;
        script.onload = () => {
          this.renderTurnstile();
        };
        document.head.appendChild(script);
      }
    },
    
    renderTurnstile() {
      // Essayer plusieurs sources pour la clé
      let siteKey = null;
      
      // 1. Variable globale window
      if (window.TURNSTILE_SITE_KEY) {
        siteKey = window.TURNSTILE_SITE_KEY;
      }
      // 2. Depuis symfony global si disponible
      else if (window.symfony && window.symfony.turnstile_site_key) {
        siteKey = window.symfony.turnstile_site_key;
      }
      // 3. Depuis this.$symfony si disponible
      else if (this.$symfony && this.$symfony.turnstile_site_key) {
        siteKey = this.$symfony.turnstile_site_key;
      }
      // 4. Chercher dans le DOM (peut-être stocké dans un meta tag)
      else {
        const metaTag = document.querySelector('meta[name="turnstile-site-key"]');
        if (metaTag) {
          siteKey = metaTag.getAttribute('content');
        }
      }
      
      // 5. En dernier recours, utiliser la clé en dur (à remplacer par votre vraie clé)
      if (!siteKey) {
        // IMPORTANT: Remplacez cette clé par votre vraie clé Turnstile
        // Cette clé est temporaire pour permettre le test
        siteKey = '0x4AAAAAAAVnYgGoBbrMTyZW'; // À REMPLACER
        console.warn('Utilisation de la clé Turnstile par défaut - À REMPLACER');
      }
      
      console.log('Utilisation de la clé Turnstile:', siteKey.substring(0, 10) + '...');
      
      // Obtenir l'élément DOM directement
      const container = document.getElementById('turnstile-widget-sms');
      if (!container) {
        console.error('Conteneur Turnstile introuvable');
        return;
      }
      
      this.turnstileWidgetId = window.turnstile.render(container, {
        sitekey: siteKey,
        callback: (token) => {
          this.turnstileToken = token;
          console.log('Token Turnstile SMS reçu');
          // Résoudre la promesse si elle existe
          if (this.turnstileResolve) {
            this.turnstileResolve(token);
            this.turnstileResolve = null;
            this.turnstileReject = null;
          }
        },
        size: 'invisible',
        'error-callback': (error) => {
          console.error('Erreur Turnstile:', error);
          this.turnstileToken = null;
          // Rejeter la promesse si elle existe
          if (this.turnstileReject) {
            this.turnstileReject(new Error('Erreur Turnstile: ' + error));
            this.turnstileResolve = null;
            this.turnstileReject = null;
          }
        }
      });
      console.log('Widget Turnstile créé avec ID:', this.turnstileWidgetId);
    },
    
    saveCountry ({iso2}) {
      this.edit.country = iso2
    },
    
    async executeTurnstileAndSend() {
      if (this.turnstileWidgetId === null || this.turnstileWidgetId === undefined) {
        throw new Error('Widget Turnstile non initialisé');
      }
      
      // Si on a déjà un token valide, le retourner
      if (this.turnstileToken) {
        console.log('Token Turnstile déjà disponible');
        return this.turnstileToken;
      }
      
      // Réinitialiser le token
      this.turnstileToken = null;
      
      // Créer une promesse qui sera résolue par le callback du widget
      this.turnstilePromise = new Promise((resolve, reject) => {
        this.turnstileResolve = resolve;
        this.turnstileReject = reject;
        
        // Timeout après 10 secondes
        setTimeout(() => {
          if (!this.turnstileToken) {
            reject(new Error('Timeout Turnstile'));
          }
        }, 10000);
      });
      
      // Exécuter le challenge
      try {
        console.log('Exécution de Turnstile...');
        window.turnstile.execute(this.turnstileWidgetId);
      } catch (error) {
        console.error('Erreur lors de l\'exécution de Turnstile:', error);
        throw error;
      }
      
      // Attendre que le callback soit appelé
      return this.turnstilePromise;
    },
    
    async beforeContinu () {
      // Vérifier le rate limit
      if (this.isRateLimited) {
        this.error = {
          title: 'Veuillez patienter',
          description: this.rateLimitMessage
        };
        return false;
      }
      
      try {
        // Exécuter Turnstile et attendre le token
        await this.executeTurnstileAndSend();
        
        // Ajouter le token aux données envoyées
        const dataToSend = {
          ...this.edit,
          'cf-turnstile-response': this.turnstileToken
        };
        
        const response = await this.sendData(dataToSend, 'phone')
        
        if (response && response.response && response.response.data && response.response.data.form_errors) {
          this.formErrors = response.response.data.form_errors
          const errors = Object.keys(this.formErrors)
          return false
        }
        
        // Si la requête est valide, activer le rate limit
        if (response && response.response && response.response.data && response.response.data.valid) {
          this.setRateLimit();
          return true;
        }
        
        return false;
      } catch (error) {
        console.error('Erreur Turnstile:', error);
        this.error = {
          title: 'Erreur de sécurité',
          description: 'Impossible de valider le captcha. Veuillez réessayer.'
        };
        return false;
      }
    },
    checkRateLimit() {
      const lastSentKey = 'lightyshare_sms_last_sent';
      const phoneKey = 'lightyshare_sms_phone';
      
      const lastSent = localStorage.getItem(lastSentKey);
      const lastPhone = localStorage.getItem(phoneKey);
      
      if (lastSent) {
        const now = Date.now();
        const timePassed = now - parseInt(lastSent);
        const timeLimit = this.rateLimitMinutes * 60 * 1000; // Convertir en millisecondes
        
        // Si c'est le même numéro ou si le délai n'est pas écoulé
        if (timePassed < timeLimit) {
          // Calculer le temps restant en secondes
          this.timeRemaining = Math.ceil((timeLimit - timePassed) / 1000);
        } else {
          // Le délai est écoulé, on peut nettoyer
          localStorage.removeItem(lastSentKey);
          localStorage.removeItem(phoneKey);
          this.timeRemaining = 0;
        }
      }
    },
    
    startRateLimitTimer() {
      // Nettoyer tout timer existant
      if (this.rateLimitTimer) {
        clearInterval(this.rateLimitTimer);
      }
      
      // Décrémenter chaque seconde
      this.rateLimitTimer = setInterval(() => {
        this.timeRemaining--;
        if (this.timeRemaining <= 0) {
          clearInterval(this.rateLimitTimer);
          this.rateLimitTimer = null;
          // Nettoyer localStorage
          localStorage.removeItem('lightyshare_sms_last_sent');
          localStorage.removeItem('lightyshare_sms_phone');
        }
      }, 1000);
    },
    
    setRateLimit() {
      const now = Date.now();
      localStorage.setItem('lightyshare_sms_last_sent', now.toString());
      localStorage.setItem('lightyshare_sms_phone', this.edit.phone);
      
      // Définir le temps restant
      this.timeRemaining = this.rateLimitMinutes * 60; // En secondes
      
      // Démarrer le timer
      this.startRateLimitTimer();
    },
  },
  components: {
    VueTelInput
  },
}
</script>

<style scoped>

</style>